import { useLocation, useNavigate, useParams } from "react-router-dom"
import { ChevronLeft } from "lucide-react"
import { Invoice, LightBtn, PageHeader } from "../../common/ui"
import {
  useFetchOrgDetailsQuery,
  useFetchOrgsSystemUsageQuery
} from "../../redux/queries"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"
import { BillingLog, Organization } from "../../types"
import { InvoiceSkeleton } from "../../common/ui/skeletons"

let month = ""

const BillingInvoice = () => {
  const { org_id = "", _id = "" } = useParams<{ org_id: string; _id: string }>()

  const location = useLocation()
  const { usage, org }: { usage?: BillingLog; org?: Organization } =
    location.state || {}

  const { data: orgFetched, isFetching: isFetchingOrg } =
    useFetchOrgDetailsQuery({ id: org_id ?? "" }, { skip: !!org || !org_id })

  const orgDetails = org || orgFetched

  // Fetch system usage for each org
  const { data: fetchedData = {}, isFetching: isFetchingUsage } =
    useFetchOrgsSystemUsageQuery(
      { orgs: [{ id: org_id }], month },
      { skip: !org_id || !!usage }
    )

  const systemUsageData =
    usage || fetchedData[org_id]?.find(log => log.id === _id)

  const isLoading =
    isFetchingOrg || isFetchingUsage || !orgDetails || !systemUsageData

  const navigate = useNavigate()

  const onClickBack = () => {
    navigate("/billing")
  }

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE.billing}>
      <>
        <div className="p-6 pt-4 sm:pt-6 border-neutral-200">
          <PageHeader title={`Billing: ${orgDetails?.name ?? ""}`}>
            <LightBtn onClick={onClickBack} text="base" size="sm">
              <ChevronLeft size={16} />{" "}
              <span className="inline-block px-1">Back</span>
            </LightBtn>
          </PageHeader>
        </div>
        <div className="px-4 py-6 md:px-6  flex-1 bg-primary-100">
          <div className="bg-white px-8 py-12 rounded-lg">
            {isLoading ? (
              <InvoiceSkeleton />
            ) : (
              <Invoice
                companyName={orgDetails?.name ?? ""}
                invoiceTimestamp={systemUsageData.timestamp}
                usage={systemUsageData.details}
              />
            )}
          </div>
        </div>
      </>
    </RequireRole>
  )
}

export default BillingInvoice
